/* eslint-disable import/no-cycle */
import PartnersColumnComponent from '../../components/PartnersColumnComponent';
import { logger } from '../../utils';
import { CType } from '../../models/Contentful/types';
import { IPartnersProps } from './@types';

const PartnersComponent: React.FC<CType<IPartnersProps>> = props => {
  try {
    const {
      fields: { ...data },
    } = props;
    return <PartnersColumnComponent {...data} />;
  } catch (error) {
    logger.error(error);
    return null;
  }
};
export default PartnersComponent;
